import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useAuth } from '../../../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { formatToZMW, rootUrl, sumOfArray } from '../../../helpers';

const AddBillModal = ({ data, onSubmit, type }) => {
    const auth = useAuth();
    const [lastType, setLastType] = useState(null);
    const [expense, setExpense] = useState(null);
    const [projects, setProjects] = useState([]);
    const [typeOptions, setTypeOptions] = useState([
        { value: "1", label: "Payment" },
        { value: "2", label: "Invoice" },
    ]);
    const [neededAmount, setNeededAmount] = useState('')
    
    const [isDis, setIsDis] = useState()
    const [entry, setEntry] = useState({
        uniId: null,
        project: null,
        amount: '',
        desc: '',
    });
    const [entriesList, setEntriesList] = useState([]);
    
    // Check if subscription exists for a given year
    const isSubscriptionActive = (year) => {
        if (!data.subscriptions || !Array.isArray(data.subscriptions)) {
            return false;
        }
        return data.subscriptions.some(sub => sub.year == year);
    };

    // Get available years from subscriptions
    const getAvailableYears = () => {
        if (!data.subscriptions || !Array.isArray(data.subscriptions)) {
            return [];
        }
        return data.subscriptions.map(sub => sub.year);
    };

    // Get default date - only set if today's year is subscribed, otherwise use earliest subscribed year or empty
    const getDefaultDate = () => {
        const today = new Date();
        const todayYear = today.getFullYear();
        const availableYears = getAvailableYears();
        
        if (availableYears.length === 0) {
            return ''; // No subscriptions available
        }
        
        // If today's year is subscribed, use today's date
        if (isSubscriptionActive(todayYear)) {
            return today.toISOString().split('T')[0];
        }
        
        // Otherwise, use the earliest available year (January 1st of that year)
        const earliestYear = Math.min(...availableYears);
        return `${earliestYear}-01-01`;
    };

    const initialFormData = {
        customer: null,
        sof: null,
        colce: null,
        bank: null,
        invoice: null,
        date: getDefaultDate(),
        entries: [],
    };

    const [formData, setFormData] = useState(initialFormData);

    // Update date when subscriptions become available
    useEffect(() => {
        if (data.subscriptions && Array.isArray(data.subscriptions) && data.subscriptions.length > 0) {
            const currentDate = formData.date;
            const currentYear = currentDate ? new Date(currentDate).getFullYear() : null;
            
            // If no date is set or current date year is not subscribed, set default date
            if (!currentDate || !isSubscriptionActive(currentYear)) {
                const today = new Date();
                const todayYear = today.getFullYear();
                const availableYears = getAvailableYears();
                
                let defaultDate = '';
                if (availableYears.length > 0) {
                    if (isSubscriptionActive(todayYear)) {
                        defaultDate = today.toISOString().split('T')[0];
                    } else {
                        const earliestYear = Math.min(...availableYears);
                        defaultDate = `${earliestYear}-01-01`;
                    }
                }
                
                if (defaultDate) {
                    setFormData(prev => ({ ...prev, date: defaultDate }));
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.subscriptions]);

    // Handle date change with subscription validation
    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        const selectedYear = new Date(selectedDate).getFullYear();
        
        if (!isSubscriptionActive(selectedYear)) {
            toast.error(`No active subscription found for year ${selectedYear}. Please select a date from a subscribed year.`);
            return;
        }
        
        setFormData({ ...formData, date: selectedDate });
    };

    // Fetch projects when budget changes
    useEffect(() => {
        if (entry.uniId) {

            const budgetData = data.budget.find(a=>a.id == entry.uniId.value)
    
            
            const fetchSpent = async () => {
                try {
                    const response = await axios.get(rootUrl(`/getProj/${entry.uniId.value}`));
                    setNeededAmount((parseFloat(budgetData?.price) * parseFloat(budgetData?.qty) * parseFloat(budgetData?.frequency)) - response.data.data.sum.num)
                  
                } catch (error) {
                    console.error('Error fetching projects:', error);
                }
            };

            fetchSpent();
        } 
    }, [entry.uniId]);

    useEffect(()=>{
    
        const fetchProjects = async () => {
            try {
                const response = await axios.get(rootUrl(`/getProjs/${auth.user.id}`));
                setProjects(response.data.data || []);

            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProjects();
   
    }, [])

    const handleEntryChange = (field, value) => {
        setEntry((prev) => ({ ...prev, [field]: value }));
    };

    const handleAddToList = () => {
        if (entry.uniId && entry.amount && entry.desc) {
            setEntriesList((prev) => [...prev, entry]);
            setEntry({ uniId: null, project: null, amount: '', desc: '' });
        } else {
            toast.info('Please fill all fields before adding to the list.');
        }
    };

    useEffect(()=>{
        
        if(type === 2 && data.suppliers.find(a=>a.id == formData.customer?.value)?.type == 1){
            let obj = []
            data.expenses.map((res)=>{
                obj.push({
                    value:res.id,
                    label:res.name
                })
            })
         
        }

    },[formData.customer])

    const handleFormSubmit = async () => {
        setIsSubmitDisabled(true)
        if (type === 2) {
            formData['lastType'] = lastType;
        }

        if(type === 2 && data.suppliers.find(a=>a.id == formData.customer?.value)?.type == 2){
            formData['expense'] = expense;
        }
        const payload = { ...formData, entries: entriesList };
        await onSubmit(payload);
        // setIsSubmitDisabled(false)
    };

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    useEffect(() => {
        setIsSubmitDisabled(
            !formData.customer ||
            !formData.sof ||
            !formData.colce ||
            !formData.bank ||
            !formData.date ||
            entriesList.length === 0 ||
            (type === 2 && !lastType)
        )
    },[formData, entriesList, type, lastType])
  
    
    
    const chtData = type === 1? data.budget.filter(a=>a.coa.substring(0,1) == type):
                    type === 2? data.budget.filter(a=>a.coa.substring(0,1) != '1'): data.budget

         const getOptionDetails = (option) => {
                        const coaDetails = data.coa?.find((a) => a.account == option.coa) || {};
                        return {
                            value: option.id,
                            label: `${option.coa} - 
                            ${type === 2?coaDetails.name || '':coaDetails.name || ''} -
                            ${data.program.find(a=>a.programCode == option.program)?.name  || ''} -

                            ${type === 2?data.subProgram.find(a=>parseFloat(a.subProgramCode) == parseFloat(option.subprogram)
                            && a.programCode == option.program
                            )?.name  || '':''} -
                            ${type === 2?option.toy || '':''} - 
                            ${data.dept.find(a=>a.id == option.dept)?.name  || ''}
                            `
                        };
                    };

                    const expType = [
                        {
                            id:411520,
                            name:"Terminal Benefits"
                        },
                        {
                            id:411140,
                            name:"ZRA"
                        },
                        {
                            id:411150,
                            name:"NAPSA"
                        },
                        {
                            id:411160,
                            name:"Pensions"
                        },
                        {
                            id:411170,
                            name:"LASF"
                        },
                        {
                            id:411190,
                            name:"Health Insurance"
                        },
                        {
                            id:411200,
                            name:"Funeral"
                        },
                        {
                            id:411210,
                            name:"Union"
                        },
                        {
                            id:322020,
                            name:"Imprest"
                        },
                        {
                            id:322070,
                            name:"Advance"
                        },
                    ]

    return (
        <div className="p-5 md:p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-5">
                <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                        {type === 2 ? "Add Supplier Transaction" : "Add Customer Transaction"}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                        Capture bill details, allocate budget lines, and link to funding sources.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Static Fields */}
                <div className="space-y-4">
                    <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                        Line Item Details
                    </h4>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Budget Item
                        </label>
                        <Select
                            options={chtData.filter(a=>a.year == new Date(formData.date).getFullYear()).map(getOptionDetails)}
                            placeholder="Select budget item"
                            onChange={(selected) => handleEntryChange('uniId', selected)}
                            value={entry.uniId}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Project
                        </label>
                        <Select
                            options={projects.map((project) => ({
                                value: project.id,
                                label: ` ${project.description}`,
                            }))}
                            placeholder="Select Project"
                            onChange={(selected) => handleEntryChange('project', selected)}
                            value={entry.project}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Amount
                        </label>
                        <input
                            type="number"
                            placeholder="Enter amount"
                            className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={entry.amount}
                            onChange={(e) => handleEntryChange('amount', e.target.value)}
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Description
                        </label>
                        <textarea
                            placeholder="Enter description for this line item"
                            className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={3}
                            value={entry.desc}
                            onChange={(e) => handleEntryChange('desc', e.target.value)}
                        />
                    </div>
                    <button
                        className="mt-1 inline-flex items-center justify-center bg-blue-950 hover:bg-blue-900 text-white font-semibold py-2 px-4 rounded-lg w-full text-sm"
                        onClick={handleAddToList}
                    >
                        Add line to bill
                    </button>
                    <div className="text-sm text-gray-700 mt-3">
                        <span className="font-medium">Budgeted Balance:</span>{" "}
                        <span className="font-semibold text-blue-950">
                            {formatToZMW(neededAmount)}
                        </span>
                    </div>
                </div>

                {/* Additional Fields */}
                <div className="space-y-4">
                    <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                        Bill Header
                    </h4>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            {type === 2 ? "Supplier" : "Customer"}
                        </label>
                        <Select
                            options={
                                type == '2'?
                                    data.suppliers.filter(a=>a.type != 3).map((option) => ({
                                          value: option.id,
                                          label: `${option.name}`,
                                      })) 
                                      : 
                                      data.suppliers.filter(a=>a.type == 3).map((option) => ({
                                        value: option.id,
                                        label: `${option.name} ${option.person}`,
                                    })) 
                            }
                            placeholder={type === 2 ? "Select Supplier" : "Select Customer"}
                            onChange={(selected) =>
                                setFormData({ ...formData, customer: selected })
                            }
                            value={formData.customer}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Source of Funds
                        </label>
                        <Select
                            options={data.sof.map((option) => ({
                                value: option.id,
                                label: `${option.source_of_fund}`,
                            }))}
                            placeholder="Source of Funds"
                            onChange={(selected) =>
                                setFormData({ ...formData, sof: selected })
                            }
                            value={formData.sof}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Collection Center
                        </label>
                        <Select
                            options={data.cc.map((option) => ({
                                value: option.id,
                                label: `${option.collection_name}`,
                            }))}
                            placeholder="Select Collection Center"
                            onChange={(selected) =>
                                setFormData({ ...formData, colce: selected })
                            }
                            value={formData.colce}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Bank
                        </label>
                        <Select
                            options={data.bank.map((option) => ({
                                value: option.id,
                                label: `${option.name}`,
                            }))}
                            placeholder="Select Bank"
                            onChange={(selected) =>
                                setFormData({ ...formData, bank: selected })
                            }
                            value={formData.bank}
                            className="text-sm"
                            isClearable
                        />
                    </div>
                    {
                        type === 2 && data.suppliers.find(a=>a.id == formData.customer?.value)?.type == 2?
                        <div className="space-y-1">
                            <label className="text-xs font-medium text-gray-600">
                                Expense Type
                            </label>
                            <Select
                                options={expType.map((option) => ({
                                    value: option.id,
                                    label: option.name,
                                }))}
                                placeholder="Select expense type"
                                onChange={(selected) => setExpense(selected)}
                                value={
                                    expense
                                }
                                className="text-sm"
                                isClearable
                            />
                        </div>
                    :null
                    }
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Cheque # / Reference
                        </label>
                        <input
                            type="text"
                            placeholder="Cheque / reference number"
                            className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.invoice}
                            onChange={(e) =>
                                setFormData({ ...formData, invoice: e.target.value })
                            }
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-600">
                            Date
                        </label>
                        <input
                            type="date"
                            placeholder="Date"
                            className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.date}
                            onChange={handleDateChange}
                            min={getAvailableYears().length > 0 ? `${Math.min(...getAvailableYears())}-01-01` : undefined}
                            max={getAvailableYears().length > 0 ? `${Math.max(...getAvailableYears())}-12-31` : undefined}
                        />
                    </div>
                    {!isSubscriptionActive(new Date(formData.date).getFullYear()) && formData.date && (
                        <p className="text-xs text-red-500 mb-1">
                            No active subscription for {new Date(formData.date).getFullYear()}. Available years: {getAvailableYears().join(', ') || 'None'}
                        </p>
                    )}
                    {type === 2 ? (
                        <div className="space-y-1">
                            <label className="text-xs font-medium text-gray-600">
                                Bill Type
                            </label>
                            <Select
                                options={typeOptions}
                                placeholder="Select type"
                                onChange={(selected) => setLastType(selected)}
                                value={
                                    typeOptions.find((option) => option.value === lastType?.value) ||
                                    null
                                }
                                className="text-sm"
                                isClearable
                            />
                        </div>
                    ) : null}
                    <button
                        className={`mt-2 py-2 px-4 rounded-lg w-full text-sm font-semibold ${
                            isSubmitDisabled
                                ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                                : 'bg-green-600 hover:bg-green-700 text-white'
                        }`}
                        onClick={handleFormSubmit}
                        disabled={isSubmitDisabled}
                    >
                        Submit
                    </button>
                </div>
            </div>

            {/* Dynamic List */}
            <div className="mt-6">
                <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">
                    Entries Summary
                </h4>
                {entriesList.length > 0 ? (
                    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
                        <table className="min-w-full border-collapse">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-4 py-2 border-b border-gray-200 text-left text-xs font-medium text-gray-600">
                                        Chart of Account
                                    </th>
                                    <th className="px-4 py-2 border-b border-gray-200 text-left text-xs font-medium text-gray-600">
                                        Project
                                    </th>
                                    <th className="px-4 py-2 border-b border-gray-200 text-right text-xs font-medium text-gray-600">
                                        Amount
                                    </th>
                                    <th className="px-4 py-2 border-b border-gray-200 text-left text-xs font-medium text-gray-600">
                                        Description
                                    </th>
                                    <th className="px-4 py-2 border-b border-gray-200 text-center text-xs font-medium text-gray-600">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {entriesList.map((item, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                        <td className="px-4 py-2 border-t border-gray-200 text-xs md:text-sm text-gray-700 align-top">
                                            {item.uniId.label}
                                        </td>
                                        <td className="px-4 py-2 border-t border-gray-200 text-xs md:text-sm text-gray-700 align-top">
                                            {item.project?.label || ''}
                                        </td>
                                        <td className="px-4 py-2 border-t border-gray-200 text-xs md:text-sm text-gray-700 text-right align-top">
                                            {item.amount}
                                        </td>
                                        <td className="px-4 py-2 border-t border-gray-200 text-xs md:text-sm text-gray-700 align-top">
                                            {item.desc}
                                        </td>
                                        <td className="px-4 py-2 border-t border-gray-200 text-center align-top">
                                            <button
                                                className="inline-flex items-center justify-center bg-red-500 text-white py-1 px-3 rounded-full hover:bg-red-600 text-xs md:text-sm"
                                                onClick={() =>
                                                    setEntriesList((prev) =>
                                                        prev.filter((_, i) => i !== index)
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="bg-gray-50">
                                    <th className="px-4 py-2 border-t border-gray-200 text-left text-xs font-medium text-gray-700" colSpan={2}>
                                        Total
                                    </th>
                                    <th className="px-4 py-2 border-t border-gray-200 text-right text-xs md:text-sm font-semibold text-gray-800">
                                        {formatToZMW(sumOfArray(entriesList.map(res=>parseFloat(res.amount))))}
                                    </th>
                                    <th className="border-t border-gray-200" colSpan={2}></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                ) : (
                    <p className="text-sm text-gray-500">
                        No entries added yet. Add at least one line item to submit the bill.
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddBillModal;
